module.exports = __webpack_public_path__ + "media/images/country_flags/ws-f7ad8d8f3591f8a06eb2eeb4767dd7cb.png";